import Vue from 'vue';

// Import and register directives
import lowercase from './lowercase';
import mask from './mask';
import syncStyle from './syncStyle';
import testId from './testId';
import tooltip from './tooltip';
import uppercase from './uppercase';

const directives = {
    mask,
    uppercase,
    lowercase,
    'test-id': testId,
    'sync-style': syncStyle,
    tooltip
};

for (const [name, directive] of Object.entries(directives)) {
    Vue.directive(name, directive);
}
